import { Checkbox, FormControlLabel, FormGroup, MenuItem } from "@mui/material";

function MenuList({ checked, onPressMenuList, title }) {
  return (
    <MenuItem disableRipple>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => onPressMenuList(e.target.checked)}
              checked={checked}
            />
          }
          label={title}
        />
      </FormGroup>
    </MenuItem>
  );
}

export default MenuList;
